import { Component, OnInit } from '@angular/core';
import { FooterComponent } from './components/home-page/footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/home-page/header/header.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [HeaderComponent, RouterOutlet, FooterComponent]
})
export class AppComponent implements OnInit {
  constructor() {}

  ngOnInit() {
  }

}
